import type { HighscoreEntry } from "../game/highscores";
import { el } from "./dom";

function formatSeconds(total: number): string {
	const s = Math.floor(total);
	return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
}

/** The survival highscore table; `highlight` marks a freshly entered rank. */
export function highscoreTable(
	list: readonly HighscoreEntry[],
	highlight = -1,
	scoreLabel = "Asteroids",
): HTMLElement {
	if (list.length === 0) {
		return el("p", { class: "page-text" }, "No highscores yet. Play Asteroid Survival to set one!");
	}
	const rows = list.map((e, i) =>
		el(
			"tr",
			{ class: i === highlight ? "highlight" : "" },
			el("td", {}, String(i + 1)),
			el("th", { scope: "row" }, e.name),
			el("td", {}, String(e.score)),
			el("td", {}, e.map),
			el("td", {}, e.rules),
			el("td", {}, formatSeconds(e.seconds)),
		),
	);
	return el(
		"table",
		{ class: "stats-table highscore-table" },
		el(
			"thead",
			{},
			el(
				"tr",
				{},
				el("th", {}, "#"),
				el("th", {}, "Pilot"),
				el("th", {}, scoreLabel),
				el("th", {}, "Map"),
				el("th", {}, "Rules"),
				el("th", {}, "Time"),
			),
		),
		el("tbody", {}, ...rows),
	);
}
